export const CONTENT_RELEASE = '2026.04.r1';

export const CONTENT_CHANGELOG = [
	{
		release: '2026.04.r1',
		releasedOn: '2026-04-27',
		owner: 'product-content',
		notes: {
			footer: [
				'Replaced generic promotional copy with practical booking and support messaging.',
				'Updated footer navigation labels for real-world user actions.',
				'Aligned legal and bottom links with customer support and refunds journey.'
			],
			offers: [
				'Replaced outdated festival campaign with a 2026 seasonal booking window.',
				'Added annual family membership offer with clear pricing and usage terms.',
				'Standardized terms, validity, and savings language for offer cards.'
			]
		}
	}
];

export const CONTENT_RELEASE_INFO =
	CONTENT_CHANGELOG.find((item) => item.release === CONTENT_RELEASE) || null;
